import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TotalSummayList, FilterTotalSummaryModel } from '@kanzi-apes/kanzi-models';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';

@Injectable({
  providedIn: 'root'
})
export class InventoryChartService {
  private itemStockUrl =
  this.envService.environment!.kongApi +
  this.envService.environment!.apiModules.inventory +
  'type-total-location/';

constructor(
  private apiClientService: KanziRestClientService,
  private envService: EnvironmentService
) {}

getStockLocationSummary(
  filters: FilterTotalSummaryModel
): Observable<TotalSummayList> {
  return this.apiClientService.get(
    this.itemStockUrl,
    filters,
    'Error al traer el Stock del servidor'
  );
}
}
